import { Button } from '@components/Button/BasicButton';
import { TextArea } from '@components/TextField/TextArea';
import { FeatureFlags } from '@constants/featureFlags';
import { isFeatureFlagEnabled } from '@store/featureFlags/store';
import { orderStore, customerStore, setOrderStore, isRep } from '@store/orders';
import { createSignal, Show } from 'solid-js';
import { PencilIcon, ContentSaveIcon } from '@atgfr8/icons';
export const PointOfSale = () => {
  const [buttonTitle, setButtonTitle] = createSignal('EDIT');
  const [editMode, setEditMode] = createSignal(false);
  const posNotes = () => {
    return (
      orderStore.order.pointOfSaleInstructions ||
      customerStore.customer.pointOfSaleInstructions
    );
  };

  return (
    <Show when={isFeatureFlagEnabled(FeatureFlags.PointOfSaleNotes)()}>
      <div class="w-full p-2 rounded-md bg-armstrong-light-blue mb-2 flex flex-col gap-2">
        <div class="flex justify-between items-center">
          <div class="text-armstrong-primary font-semibold text-xl">
            Customer Point of Sale Notes
          </div>
          <Button
            startIcon={
              editMode() ? (
                <ContentSaveIcon size={20} />
              ) : (
                <PencilIcon size={20} />
              )
            }
            disabled={!isRep()}
            onClick={() => {
              setEditMode(!editMode());
              setButtonTitle(buttonTitle() === 'EDIT' ? 'UPDATE' : 'EDIT');
            }}
          >
            {buttonTitle()}
          </Button>
        </div>
        <Show
          when={!editMode()}
          fallback={
            <div>
              <TextArea
                label="Notes"
                value={posNotes()}
                infoText="Customer Profile POS notes section will be displayed here. Notes are intended for internal use only. Edits made here will not be saved to POS notes within customer profile."
                maxChar={2000}
                placeholder="Add customer point of sale notes for this order."
                onChange={(e) => {
                  setOrderStore('order', {
                    pointOfSaleInstructions: e.target.value,
                    operationType: 'Update',
                  });
                }}
              />
            </div>
          }
        >
          <Show when={posNotes()}>
            <div class="text-black whitespace-pre-wrap min-h-0">
              {posNotes()}
            </div>
          </Show>
        </Show>
      </div>
    </Show>
  );
};
